var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radiobox-wrap"},[_c('input',{ref:"radiobox",staticClass:"radiobox",class:{ active: _vm.isChecked },attrs:{"type":"checkbox"},on:{"click":_vm.clickRadio}})])}
var staticRenderFns = []

export { render, staticRenderFns }